<template>
    <div class="modal-goodslist">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">{{name}}修改</div>
                <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            </div>
            <div class="modal-body">
                <el-form :model="addForm" ref="addForm" label-width="80px">
                    <div>
                        <el-row>
                            <el-col :span="22" class="item">
                                <el-form-item label="上传文件" required>
                                    <el-upload
                                        class="upload-demo"
                                        drag
                                        ref="upload"
                                        :action="uploadUrl"
                                        :data='uploadData'
                                        :on-remove="removeFile"
                                        :on-success="uploadSuccess"
                                        :on-exceed="handleExceed"
                                        :file-list="batchFileList"
                                        :limit='1'
                                        multiple>
                                        <i class="el-icon-upload"></i>
                                        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                                        <div class="el-upload__tip" slot="tip">修改上传.docx/excel文件</div>
                                    </el-upload>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                </el-form>
            </div>
            <div class="modal-footer">
                <el-button :loading="loading" type="primary" @click="confirm('addForm')">修改</el-button>
            </div>
        </div>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";

    export default {
        name: 'Edit',
        data() {
            return {
                loading: false,
                uploadUrl:this.$institutionUrl+'Upload/File',
                name:"",
                uploadData:{
                    staffCode:getStaffCode(),
                    timeStr:timeStr,
                    sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey)
                },
                batchFileList:[],
                addForm:{
                    staffCode:getStaffCode(),
                    timeStr:timeStr,
                    sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                    printItemCode:"",
                    url:"",
                },

            }
        },

        methods: {

            init(row){
                
                this.name=row.printClass.name;
                this.addForm.url = row.url;
                this.addForm.printItemCode = row.printItemCode;
                console.log(this.name);
                console.log(this.addForm.url);
                let filePath = row.url.split(".");
                this.batchFileList=[{
                    name:this.name+"."+filePath[1],
                    url:row.url
                }]
            },
            handleExceed() {
                this.$message.error(`只能上传1个文件，如果需要更改请去除当前文件`);
            },
            uploadSuccess(response){
                let that = this;
                if(response.error == 0){
                    console.log(response.data.path)
                   that.addForm.url = response.data.path;
                }else if(response.error == 1){
                    this.$message({type: 'info', message: response.message});
                }
            },
            removeFile(){
                this.addForm.url="";
            },

            closeSelf() {
                this.$emit("closeEdit");
            },

            confirm(addForm){
                console.log(addForm)
                if(this.addForm.url==""){
                    this.$message("文件地址不能为空");
                    return;
                }
                this.addSubmit();
            },

            addSubmit(){

                if(this.loading){
                    return;
                }else{
                    this.loading = true;
                }

                this.addForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);

                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"PrintItem/Edit",
                    data: this.addForm
                }).then(
                    (response) => {
                        console.log(response);
                        this.loading = false;

                        if (response.data.error == 0) {
                            this.$emit("closeEdit");
                            this.$emit("getList");
                        } else {
                            this.$message({type: 'info', message: '添加失败'});
                        }

                    }
                )
            },


        }
    }


</script>


<style lang="scss" scoped>

    .modal-goodslist {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0, 0, 0, .3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99;

        .modal {
            background-color: #fff;
            box-shadow: 2px 2px 20px 1px;
            overflow-x: auto;
            display: flex;
            flex-direction: column;
            border-radius: 10px;
            width: 600px;

            .modal-header {
                border-bottom: 1px solid #eee;
                color: #313131;
                justify-content: space-between;
                padding: 10px;
                display: flex;
            }

            .modal-body {
                position: relative;
                padding: 20px 0px;
                z-index: 99;
                overflow-y: scroll;
                height: auto;
            }

            .modal-footer {
                border-top: 1px solid #eee;
                justify-content: flex-end;
                padding: 15px;
                display: flex;
            }


        }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left: 16px;
        width: 56px;
        height: 36px;
        border: none;
        cursor: pointer;
    }

    .btn-close {
        color: #313131;
        background-color: transparent;
    }


    .row {
        padding: 10px 0px;
    }

    .item {
        padding: 0px 20px;
    }

    .label {
        padding: 5px 0px;
    }
    /deep/ .el-upload-dragger {
        width: 405px;
    }


</style>
